"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tokens = __importStar(require("../utils/DesignTokens/tokens"));
var prepareShadowSizeFor = function (identifier) {
    return Tokens["SizeShadow" + identifier + "HOffset"] + " " + Tokens["SizeShadow" + identifier + "VOffset"] + " " + Tokens["SizeShadow" + identifier + "BlurRadius"] + " " + Tokens["SizeShadow" + identifier + "SpreadRadius"];
};
var CompleteTheme = __assign(__assign({}, Tokens), { SizeShadowButtonActive: prepareShadowSizeFor('ButtonActive'), SizeShadowButtonFloating: prepareShadowSizeFor('ButtonFloating'), SizeShadowCheckbox: prepareShadowSizeFor('Checkbox'), SizeShadowRadio: prepareShadowSizeFor('Radio'), SizeShadowDialog: prepareShadowSizeFor('Dialog'), SizeShadowSwitchCircleBase: prepareShadowSizeFor('SwitchCircleBase'), SizeShadowSwitchCircleHover: prepareShadowSizeFor('SwitchCircleHover'), SizeShadowToastBase: prepareShadowSizeFor('ToastBase'), SizeShadowTooltipText: prepareShadowSizeFor('TooltipText'), SizeShadowTooltipDialog: prepareShadowSizeFor('TooltipDialog'), SizeShadowInputActive: prepareShadowSizeFor('InputActive'), zIndex: {
        default: 0,
        bottomLayer: -1,
        topLayer: 9999
    } });
var defaultTheme = CompleteTheme;
exports.default = defaultTheme;
//# sourceMappingURL=defaultTheme.js.map